import React from 'react'
import { FilterComponent } from '../../components/_WMS/FilterComponent/FilterComponent'
import { Filter } from '../../components/_WMS/FilterComponent'
import { filterOptions } from './config'
import { FilterExtraAction } from '../../components/_WMS/FilterComponent/types'

export interface FilterOption {
  order: number
  key: string
  label: string
  type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
  options?: []
  Component?: React.ComponentType<ComponentProps> // Solo para 'custom'
  // Otras propiedades que puedas necesitar para tipos específicos
}

interface ComponentProps {}
interface InventoryCheckSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  onAddButtonClick?: () => void
  addButtonTitle?: string
  createButtonTooltip?: string
  extraActions?: FilterExtraAction[]
  includeSearchOnClean: boolean
}

export const InventoryCheckSearch: React.FC<InventoryCheckSearchProps> = ({
  onSearchClick,
  selectedFilters,
  setSelectedFilters,
  includeAddButton,
  onAddButtonClick,
  addButtonTitle,
  createButtonTooltip,
  extraActions,
  includeSearchOnClean
}) => {
  return (
    <FilterComponent
      options={filterOptions}
      onSearchClick={onSearchClick}
      selectedFilters={selectedFilters}
      setSelectedFilters={setSelectedFilters}
      includeAddButton={includeAddButton}
      onAddButtonClick={onAddButtonClick}
      addButtonTitle={addButtonTitle}
      createButtonTooltip={createButtonTooltip}
      extraActions={extraActions}
      includeSearchOnClean={includeSearchOnClean}
    />
  )
}